<template>

  <div>

    <h3 class="subtitle">{{label}}</h3>

      <div v-for="option in options" :key="option.solver_id">
         <label :for="option.solver_id">
          <input :name="name" :id="option.solver_id" @change="updateSetting" :checked="value === option.solver_id" :value="option.solver_id" type="radio" />
          <figure class="texture" :style="{background:getTexture(option.solver_id)}">
             {{option.name}}
             <b-icon class="is-light icon" pack="mdi" icon="check"></b-icon>
          </figure>
         
        </label>

      </div>

  </div>

</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";

  export default {

    name: 'TextureSelectField',

    props: ['multi', 'options', 'name',  'label', 'value','icon', 'default', 'applyTo'],

    computed : {
      
      ...mapGetters(['getTexture']),

      valueOrDefault(){        
        return (this.value)?this.value:this.default;
      }
    },

    methods:{
     
      updateSetting(e){    
        this.$emit('change', {name:this.name, value:e.target.value});
      }

    }
 
  }
    
</script>

<style scoped>

  [type=radio] {
    visibility:hidden;
    display:none;
  }

  [type=radio] + figure{
    margin-bottom:0.5em;
  }

  [type=radio] + figure {
    cursor: pointer;
  }

  .texture{
    border-radius:0.4em;
    color:white;
    padding:1em;
    font-weight: bold;
    text-shadow: 0 0 1px black;
  }

  .texture:hover{
      transform:scale(1.03);
      opacity:0.8;
  }

  .icon{
    float:right;
    display: none;
    background:#fff;
    text-shadow: none;
    border-radius: 50%;
    color:black;
    width:30px;
    height:30px;
    text-align: center;
  }

  [type=radio]:checked + figure .icon{
    display: inline-block;
  }

</style>
